import React from 'react';

import * as SearchT3Actions from './actions';
import * as SearchT3Constants from './constants';
import * as D from './deps';
import SearchReducer from './reducer';
import SearchT3Watchers from './sagas/watchers';
import * as SearchT3Selectors from './selectors';
import * as SearchT3Utils from './utils';

export default D.createDomainModule({
  name: 'searchT3',
  actions: SearchT3Actions,
  reducer: SearchReducer,
  constants: SearchT3Constants,
  selectors: SearchT3Selectors,
  utils: SearchT3Utils,
  persisted: false,
  components: {
    SearchModal: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_search-modal" */ './containers/SearchModal/SearchModal',
            )
          }
        />
      );
    },
    BabySearchInput: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_baby-search-input" */ './components/BabySearchInput/BabySearchInput.jsx',
            )
          }
        />
      );
    },
    SearchPlaceholder: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_search-placeholder" */ './components/SearchPlaceholder/SearchPlaceholder.jsx',
            )
          }
        />
      );
    },
  },
  onStart() {
    this.registerHandlers = D.registerHandlers(SearchT3Watchers);
  },
  onStop() {
    D.removeAndStopHandlers(this.registerHandlers, this.name);
  },
});
